import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import {get} from 'lodash';

class SurveyDeleteInstancesButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    handleDelete() {
        this.setState({modal: false}, () => this.props.onClick());
    }

    toggleModal() {
        if (!this.props.disabled) {
            this.setState({modal: !this.state.modal});
        }
    }

    render() {
        const {children, className, disabled, item} = this.props;
        const warning = get(item, 'stats.sent', 0) > 0;

        return (
            <a className={classNames(className, {disabled, 'text-danger': !disabled})} onClick={this.toggleModal}>
                {children}
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.removeInstances.title} values={{name: item.name}} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.removeInstances.body} values={{name: item.name}} />
                        {warning &&
                            <div className="text-danger bold">
                                <FormattedMessage {...messages.surveys.modals.removeInstances.warning} />
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.handleDelete}>
                            <Icon icon="trash" /><FormattedMessage {...messages.surveys.button.remove} />
                        </button>
                    </ModalFooter>
                </Modal>
            </a>
        );
    }
}

export default SurveyDeleteInstancesButton;
